// ------------------ config (static)
/* eslint-disable-next-line no-unused-vars */
const SubmitReviewService = (() => {
	// private var(s)
    const _sku = ""
    const _parentSku = ""
    const _name = ""
	const _orderId = ""
	const _isReviewWritten= false;
	const  _reviewSuccess = {orderId:'', sku:''};
	const _productId= ""
	// private method(s)
	const _constructor = () => {
	};

	_constructor();

	// output/public
	return {
        orderId: _orderId,
		sku: _sku,
		parentSku: _parentSku,
		productId: _productId,
		name: _name,
		isReviewWritten : _isReviewWritten,
		reviewSuccess: _reviewSuccess
	};
})();
